<template>
    <div class="row justify-content-center mx-0">
        <div class="col-12">
            <h4 class="text-primary">{{trans('courses.multicircle_exercise.characteristics_end_title')}}</h4>
        </div>
        <div class="col-5 text-center my-4">
            <b-img src="/images/multicircle/exercise-end.png" fluid/>
        </div>

        <div class="col-12 text-center">
            <p v-html="trans('courses.multicircle_exercise.characteristics_end_description')" />
        </div>

        <div class="col-12 d-flex justify-content-end">
            <b-button 
                variant="link" 
                class="my-2 mr-3" 
                @click="$emit('secondaryClicked')"> 
                    {{ buttonSecondaryText }}
            </b-button>
            <b-button 
                class="my-2" 
                variant="secondary" 
                @click="$emit('primaryClicked')">
                    {{ buttonPrimaryText }}
            </b-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "ExerciseEnd",
    props: {
        buttonPrimaryText: String,
        buttonSecondaryText: String
    }
}
</script>
